import { readUserProfile } from '@/store/main/getters';

function getDisabled(store, display, control){
    const userProfile = readUserProfile(store);
    if (!userProfile || !userProfile.permission || !userProfile.permission.config) {
        return false;
    }
    const permission = userProfile.permission.config[display];
    if (!permission) {
        return false;
    }
    return Reflect.get(permission, control) || false;
}

export default {
    getDisabled
}
